function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2019, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
import React, { Component } from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import { Modal } from "@carbon/react";
import { IntlProvider } from "react-intl";
import SecretDialogFields from "../common/SecretDialogFields";
import vaultUtil from "../../utils/vault-util";
var SecretPickerDialog = /*#__PURE__*/function (_Component) {
  function SecretPickerDialog(props) {
    var _this;
    _classCallCheck(this, SecretPickerDialog);
    _this = _callSuper(this, SecretPickerDialog, [props]);
    _this.state = {
      cumulativeState: "idle",
      hasError: false,
      noIntegrations: false,
      // from SecretDialogFields, updated in onFieldChange
      provider: "",
      region: "",
      resource_group: "",
      resource_group_name: "",
      instance: "",
      group: "",
      // note is a secret-group, not resource-group
      secret: "",
      field: "",
      subdir: "",
      basePath: ""
      // subdirHelper: "", is set but not used
      // toolcardName: "",
      // reference: ""
    };
    autoBind(_this);
    return _this;
  }
  _inherits(SecretPickerDialog, _Component);
  return _createClass(SecretPickerDialog, [{
    key: "onFieldChange",
    value: function onFieldChange(fieldname, newValue, hasError, callback) {
      if (callback && typeof callback === "function") {
        this.setState(_defineProperty(_defineProperty({}, fieldname, newValue), "hasError", hasError), callback);
      } else {
        this.setState(_defineProperty(_defineProperty({}, fieldname, newValue), "hasError", hasError));
      }
    }
  }, {
    key: "onMultipleFieldsChange",
    value: function onMultipleFieldsChange(fieldNameValuePairs) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$hasError = _ref.hasError,
        hasError = _ref$hasError === void 0 ? false : _ref$hasError,
        callback = _ref.callback;
      var usedCallback = callback && typeof callback === "function" ? callback : undefined;
      this.setState(function /* prevState */
      () {
        return _objectSpread(_objectSpread({}, fieldNameValuePairs), {}, {
          hasError: hasError
        });
      }, usedCallback);
    }
  }, {
    key: "onCumulativeStateChange",
    value: function onCumulativeStateChange(cumulativeState) {
      // cumulativeState: "fetching" | "idle"
      this.setState({
        cumulativeState: cumulativeState
      });
    }
  }, {
    key: "onClickOk",
    value: function onClickOk() {
      var _this$props$noIntegra;
      if (this.state.noIntegrations && (_this$props$noIntegra = this.props.noIntegrationsModal) !== null && _this$props$noIntegra !== void 0 && _this$props$noIntegra.okAction) {
        // Use custom handler for noIntegrations error case
        this.props.noIntegrationsModal.okAction(this.props.onClose);
        return;
      }
      var _metadata = {};
      if (this.state.provider === vaultUtil.KP_PROVIDER_TYPE) {
        _metadata.reference = "{".concat(vaultUtil.KP_REFERENCE_TYPE, "::") + "".concat(this.state.region, ".") + "".concat(this.state.resource_group_name, ".") + "".concat(this.state.instance, ".") + "".concat(this.state.secret, "}");
        _metadata.toolcard = false;
      } else if (this.state.provider === vaultUtil.SM_PROVIDER_TYPE) {
        _metadata.reference = "{".concat(vaultUtil.SM_REFERENCE_TYPE, "::") + "".concat(this.state.region, ".") + "".concat(this.state.resource_group_name, ".") + "".concat(this.state.instance, ".") + "".concat(this.state.group, ".") + "".concat(this.state.secret) + "".concat(this.state.field ? ".".concat(this.state.field) : "") + "}";
        _metadata.toolcard = false;
      } else if (this.state.provider.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.KP_PROVIDER_TYPE, ":"))) {
        var toolcardName = this.state.provider.substring("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.KP_PROVIDER_TYPE, ":").length);
        _metadata.reference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::") + "".concat(toolcardName, ".") + "".concat(this.state.secret) + "}";
        _metadata.toolcard = true;
      } else if (this.state.provider.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.HV_PROVIDER_TYPE, ":"))) {
        var _toolcardName = this.state.provider.substring("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.HV_PROVIDER_TYPE, ":").length);
        if (this.state.subdir && this.state.subdir.length > 0 && this.state.basePath && this.state.subdir.startsWith(this.state.basePath)) {
          var _subdir_path = this.state.subdir.substring(this.state.basePath.length + 1);
          if (_subdir_path.length > 0 && !_subdir_path.endsWith("/")) {
            _subdir_path += "/";
          }
          _metadata.reference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::") + "".concat(_toolcardName, ".") + "".concat(_subdir_path) + "".concat(this.state.group) + "".concat(this.state.secret ? ".".concat(this.state.secret) : "") + "}";
        } else {
          _metadata.reference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::") + "".concat(_toolcardName, ".") + "".concat(this.state.group) + "".concat(this.state.secret ? ".".concat(this.state.secret) : "") + "}";
        }
        _metadata.toolcard = true;
      } else if (this.state.provider.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.SM_PROVIDER_TYPE, ":"))) {
        var _toolcardName2 = this.state.provider.substring("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.SM_PROVIDER_TYPE, ":").length);
        if (this.state.crn) {
          _metadata.reference = this.state.crn;
        } else {
          _metadata.reference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::") + "".concat(_toolcardName2, ".") + "".concat(this.state.group, ".") + "".concat(this.state.secret) + "".concat(this.state.field ? ".".concat(this.state.field) : "") + "}";
        }
        _metadata.toolcard = true;
      } else if (this.state.provider.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.REF_SM_PROVIDER_TYPE, ":"))) {
        _metadata.reference = "ref://secrets-manager." + "".concat(this.state.region, ".") + "".concat(encodeURIComponent(this.state.resource_group_name), ".") + "".concat(encodeURIComponent(this.state.instance), "/") + "".concat(encodeURIComponent(this.state.group), "/") + "".concat(encodeURIComponent(this.state.secret)) + "".concat(this.state.field ? "?key=".concat(encodeURIComponent(this.state.field)) : "");
        _metadata.toolcard = false;
      }
      this.props.onSecretChosen(_metadata);
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.props.onClose();
    }
  }, {
    key: "updateModalState",
    value: function updateModalState(newState) {
      this.setState(newState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$noIntegra2, _this$props$noIntegra3, _this$props$noIntegra4;
      var _this$props = this.props,
        label = _this$props.label,
        modalHeading = _this$props.modalHeading,
        modalOpen = _this$props.modalOpen;
      var i18nStrings = this.props.i18n.messages;
      var idPrefix = this.props.idPrefix ? "".concat(this.props.idPrefix, "-") : "";
      var isOkDisabled = !(this.state.noIntegrations && (_this$props$noIntegra2 = this.props.noIntegrationsModal) !== null && _this$props$noIntegra2 !== void 0 && _this$props$noIntegra2.okAction) && (this.state.cumulativeState === "fetching" || this.state.hasError);
      var props = {
        open: modalOpen,
        primaryButtonText: this.state.noIntegrations && ((_this$props$noIntegra3 = this.props.noIntegrationsModal) === null || _this$props$noIntegra3 === void 0 ? void 0 : _this$props$noIntegra3.okString) || i18nStrings.buttonOK,
        secondaryButtonText: i18nStrings.buttonCancel,
        primaryButtonDisabled: isOkDisabled,
        modalHeading: this.state.noIntegrations && ((_this$props$noIntegra4 = this.props.noIntegrationsModal) === null || _this$props$noIntegra4 === void 0 ? void 0 : _this$props$noIntegra4.heading) || modalHeading || label,
        modalAriaLabel: label,
        onRequestClose: this.onClose,
        onRequestSubmit: this.onClickOk
      };
      var UIprops = _objectSpread(_objectSpread({}, this.props), {}, {
        onFieldChange: this.onFieldChange,
        onMultipleFieldsChange: this.onMultipleFieldsChange,
        onCumulativeStateChange: this.onCumulativeStateChange,
        updateModalState: this.updateModalState,
        region: this.state.region,
        resource_group: this.state.resource_group,
        provider: this.state.provider,
        instance: this.state.instance,
        group: this.state.group,
        secret: this.state.secret,
        field: this.state.field,
        subdir: this.state.subdir,
        basePath: this.state.basePath,
        mock: this.props.mock,
        mode: "retrieve",
        noIntegrations: this.state.noIntegrations
      });
      return /*#__PURE__*/React.createElement(IntlProvider, {
        locale: this.props.i18n.locale,
        messages: i18nStrings
      }, /*#__PURE__*/React.createElement(Modal, _extends({}, props, {
        hasForm: true,
        className: "ocr--secret-picker-modal"
      }), !this.state.noIntegrations && /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-description"
      }, i18nStrings.infoSecretPicker), /*#__PURE__*/React.createElement(SecretDialogFields, _extends({
        id: "".concat(idPrefix, "secret-dialog-fields-retrieve")
      }, UIprops))));
    }
  }]);
}(Component);
SecretPickerDialog.propTypes = {
  label: PropTypes.string,
  modalOpen: PropTypes.bool,
  noIntegrationsModal: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSecretChosen: PropTypes.func.isRequired,
  accountContext: PropTypes.string.isRequired,
  bssAccount: PropTypes.string.isRequired,
  envId: PropTypes.string,
  idPrefix: PropTypes.string,
  mock: PropTypes.bool,
  i18n: PropTypes.object.isRequired
};
SecretPickerDialog.defaultProps = {
  label: "",
  modalOpen: false,
  mock: false,
  idPrefix: ""
};
export default SecretPickerDialog;